<header *ngIf="Individual && Individual.cst_recno" class="row">
	<div bsMigration class="col-xs-6 text-left">{{ Individual.ind_full_name_cp }}</div>
	<div bsMigration class="col-xs-6 text-right">Member <a target="_top" href="/members?refresh=2&destination=members/renew">#</a>{{ Individual.cst_recno }}</div>
</header>
